<template>
  <div class="animated fadeIn">
    <b-card class="info-header-card" no-body>
      <b-card-header>
        <span class="text-muted text-uppercase">
          {{ heading }}
        </span>
      </b-card-header>
      <b-card-body>
        <template v-if="submission_questions.length">
          <service-question-input-row
            v-for="(question, index) in submission_questions"
            :key="index"
            :laboratory="laboratory"
            :sample_type="sample_type"
            :form_level="form_level"
            :question="question"
            :index="index"
            @updateQuestion="handleUpdateQuestion"
            @deleteQuestion="handleDeleteQuestion"
          />
        </template>
        <b-button
          variant="outline-primary"
          :block="true"
          @click="addEmptyQuestion"
        >
          <i class="fal fa-plus" /> Add Another Question
        </b-button>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import ServiceQuestionInputRow from "./ServiceQuestionInputRow";

const laboratoryRepository = LabRepositoryFactory.get("laboratory");

export default {
  name: "ServiceQuestionTypeForm",
  components: {
    ServiceQuestionInputRow
  },
  props: {
    laboratory: {
      type: Object,
      required: true,
      default: () => null
    },
    sample_type: {
      type: Object,
      required: false,
      default: () => null
    },
    heading: {
      type: String,
      required: false,
      default: null
    },
    form_level: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      submission_questions: [{}]
    };
  },
  methods: {
    fetchServiceQuestions() {
      if (this.laboratory.id) {
        let form_level = this.form_level;
        let laboratory_id = this.laboratory.id;
        let sample_type_id = this.sample_type ? this.sample_type.id : null;

        return new Promise((resolve, reject) => {
          laboratoryRepository
            .getServiceQuestionsByType(
              laboratory_id,
              sample_type_id,
              form_level
            )
            .then(response => {
              if (response && response.status === 200 && response.data) {
                let data = [];
                for (let i in response.data) {
                  let temp = response.data[i];
                  data.push(temp);
                }
                resolve(data);
              } else {
                reject();
              }
            })
            .catch(err => {
              reject(err);
            });
        });
      }
    },
    addEmptyQuestion() {
      this.submission_questions.push({});
    },
    handleDeleteQuestion(index) {
      this.submission_questions.splice(index, 1);

      this.updateTypeQuestions();
    },
    handleUpdateQuestion(data) {
      Object.assign(this.submission_questions[data.index], data);

      this.updateTypeQuestions();
    },
    updateTypeQuestions() {
      this.$emit("updateTypeQuestions", {
        form_level: this.form_level,
        data: this.submission_questions
      });
    }
  },
  watch: {
    submission_questions: {
      handler() {
        if (!this.submission_questions.length) {
          this.submission_questions.push({});
        }
      }
    }
  },
  mounted() {
    this.fetchServiceQuestions().then(submission_questions => {
      this.submission_questions = submission_questions;
    });
  }
};
</script>
